import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'TPV'

export const TPVEP : EndPointConfig[] =[
        
        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("PreAuthorization"),   

        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("VoidPayment"),   
             
        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("SettlePayment"),   
]

